function TextField({value, handleChange, placeholder}: any) {
  return (
      
        <textarea
          value={value}
          onChange={(e) => handleChange(e.target.value)}
          placeholder={placeholder}
          className="bg-white w-full md:w-[24rem] p-5 rounded-md border-black border font-boska text-lg md:text-xl font-light"
        />
  )
}

export default TextField